/** React */
import React, { HTMLAttributes } from "react";

/** Hook */
import { useMenu } from "./menu-root";

/** Props */
type Props = HTMLAttributes<HTMLDivElement> & {
  "data-menu-id"?: string | undefined;
};

export function MenuContent({ children, ...props }: Props) {
  const { items } = useMenu();
  const menuId = props["data-menu-id"];
  const isExpanded = menuId ? items[menuId]?.isExpanded : false;

  if (!isExpanded) return null;

  return <div {...props}>{children}</div>;
}

MenuContent.displayName = "MenuContent";
